export default {
      id: "obd__cumulative_fuel_economy-usage",
      viewBox: "0 0 22 15",
      url: __webpack_public_path__ + "img/icons.svg#obd__cumulative_fuel_economy",
      toString: function () {
        return this.url;
      }
    }